import React from 'react';
import PropTypes from 'prop-types';

const MaleResidentLandlord = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.79 17.198c-3.263.56-6.79.445-6.79 3.654v2.507h17.459v-2.507c0-3.21-3.76-3.073-7.14-3.654M9.355 17.97l-.006 5.39"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.421 17.995c1.164-.393 3.492-1.574 3.88-3.935 1.164 0 1.164-2.362 0-2.362l-.904-2.06H6.451l-.91 2.06c-1.164 0-1.164 2.362 0 2.362.388 2.361 2.716 3.542 3.88 3.935Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.097 11.818c0-.435.347-.393.776-.393.43 0 .776-.042.776.393M9.93 11.818c0-.435.348-.393.777-.393.429 0 .776-.042.776.393"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M11.627 19.549c-.21 0-.38.173-.38.385 0 .212.17.385.38.385s.38-.173.38-.385a.383.383 0 0 0-.38-.385ZM7.441 19.58c-.21 0-.38.173-.38.385 0 .212.17.385.38.385s.38-.173.38-.385a.383.383 0 0 0-.38-.385ZM11.627 21.088c-.21 0-.38.173-.38.385 0 .213.17.385.38.385s.38-.172.38-.385a.383.383 0 0 0-.38-.385ZM7.441 21.086c-.21 0-.38.173-.38.385 0 .213.17.385.38.385s.38-.172.38-.385a.383.383 0 0 0-.38-.385Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      d="M5.494 11.62s-.7-.613-.498-1.853c.6-3.668 8.567-3.71 8.874 0 .087 1.051-.482 1.853-.482 1.853"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m17.338 4.7.002-.005m-2.468-1.337 2.222-1.455a1.5 1.5 0 0 1 2.076.433l1.067 1.63a1.501 1.501 0 0 1-.432 2.076l-.186.122 2.648 4.044c.135.205.192.45.164.694l-.015.09-.125.598a.521.521 0 0 1-.556.413l-.06-.01-.598-.124a1.043 1.043 0 0 1-.606-.375l-.053-.074-.168-.256.213-1.02-1.02-.213.212-1.02-1.02-.213-.866-1.323-.186.122a1.5 1.5 0 0 1-2.076-.433l-1.068-1.63a1.497 1.497 0 0 1 .433-2.076Z"
    />
  </svg>
);

MaleResidentLandlord.propTypes = {
  color: PropTypes.string
};

export default MaleResidentLandlord;
